module.exports = __webpack_public_path__ + "static/img/office (4).44a021db.jpg";